<template>
  <div>
    <div class="page-title parallax parallax1 ">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="page-title-content text-center">
              <div class="breadcrumbs">
                <ul>
                  <li><a href="/">Home</a></li>
                  <li class="blog"><a href="/article">Activities</a></li>
                </ul>
              </div>
              <div class="page-title-heading">
                <h2 class="title">ACTIVITIES</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.page-title -->
    <div class="main-blog-grid3">
      <div class="container">
        <div class="row straight">
          <div
            class="col-lg-4 col-md-4 col-sm-4"
            v-for="(item, index) in articles"
            :key="index"
          >
            <article class="post mb-mgtop0" @click="onItemClick(item)">
              <div class="post-border">
                <div class="featured-post">
                  <!-- <img src="@/assets/images/grid1.jpg" alt="image" /> -->
                  <img :src="item.first_pic" alt="image" />
                </div>
                <div class="content-post">
                  <div class="post-title">
                    <span
                      ><a>{{ item.title }}</a></span
                    >
                  </div>
                  <div class="post-content">
                    <h2>
                      <a>{{ item.contentText }}</a>
                    </h2>
                  </div>
                  <div class="post-meta">
                    <span
                      ><a>{{ item.createTime }}</a></span
                    >
                  </div>
                  <div class="post-button">
                    <a href="#"
                      >READ MORE
                      <i class="fa fa-long-arrow-right" aria-hidden="true"></i
                    ></a>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
      <div class="blog-pagination text-center" v-if="pageCount > 1">
        <ul class="flat-pagination">
          <li class="prev" @click="onPrevClick">
            <a class=" hvr-shutter-out-horizontal">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </a>
          </li>
          <li
            v-for="index in indexs"
            :key="index"
            @click="onPageNumClick(index)"
          >
            <a
              class=" hvr-shutter-out-horizontal"
              v-bind:class="{ active: page === index }"
            >
              {{ index }}
            </a>
          </li>
          <li class="next" @click="onNextClick">
            <a class=" hvr-shutter-out-horizontal">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </a>
          </li>
          <li>
            <a> {{ page }} / {{ pageCount }} </a>
          </li>
          <li>
            <a> Total: {{ total }} </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- /main-blog-grid -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      num: 6,
      total: 0,
      articles: []
    }
  },
  computed: {
    indexs: function() {
      var left = 1
      var right = this.pageCount
      var ar = []
      if (this.pageCount >= 5) {
        //这里最大范围从3到6，如果到达7，那么下边加2变成9，已经超过最大的范围值
        if (this.page > 3 && this.page < this.pageCount - 2) {
          //以4为参考基准，左面加2右边加2
          left = this.page - 2
          right = this.page + 2
        } else {
          if (this.page <= 3) {
            left = 1
            right = 5
          } else {
            right = this.pageCount
            left = this.pageCount - 4
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    },
    pageCount() {
      return Math.ceil(this.total / this.num)
    }
  },
  mounted() {
    this.queryArticles()
  },
  methods: {
    onItemClick(item) {
      this.$router.push({
        path: '/article/detail',
        query: { id: item.newsGuid }
      })
    },
    onPageNumClick(pagenum) {
      this.page = pagenum
      this.queryArticles()
    },
    onNextClick() {
      if ((this.page + 1) * this.num > this.total) return
      this.page++
      this.queryArticles()
    },
    onPrevClick() {
      if ((this.page - 1) * this.num <= 0) return
      this.page--
      this.queryArticles()
    },
    queryArticles() {
      let _this = this
      this.$http
        .get('/api/articles/QueryArticles', {
          page: this.page,
          pagesize: this.num
        })
        .then(res => {
          res.data.articles.forEach(item => {
            item.createTime = new Date(item.createTime).format('en')
            item.first_pic = _this.getFirstPic(item.content)
            if (item.first_pic.indexOf('http') == -1) {
              item.first_pic = item.first_pic || '/img/grid5.jpg'
            }
            item.contentText = _this.filterText(item.content)
          })
          _this.articles = res.data.articles
          _this.total = res.data.total
        })
    },
    getFirstPic(str) {
      let data = ''
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function(match, capture) {
        data = capture
      })
      return data
    },
    filterText(str) {
      str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
      str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
      str = str.replace(/ /gi, '') // 去掉
      str = str.replace(/&nbsp;/gi, '') // 去掉
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.post-title {
  height: 60px;
}
.featured-post {
  height: 250px;
  overflow: hidden;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
.post-content {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
